import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=740a8496"
import script from "./PrincipalPage.js?vue&type=script&lang=js&external"
export * from "./PrincipalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports